export default __webpack_public_path__ + "static/media/PortoFiraSuites.aea63829.png";